import styled from 'styled-components/macro'

import { colors } from 'styled/theme.styled'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 4px;
  text-transform: uppercase;

  color: ${colors.white};
  z-index: 0;

  > .Background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${colors.darkBlue};
    z-index: -1;
  }

  > * + * {
    margin-top: 16px;
    text-align: center;
  }

  > .Title {
    font-size: 64px;
    font-weight: bold;
    text-align: center;
    color: ${colors.white};
    letter-spacing: 50px;
    filter: blur(16px);

    /* @supports (-webkit-text-stroke: 1px ${colors.white}) {
      color: transparent;
      -webkit-text-stroke: 1px ${colors.white};
    } */
  }


  .VideoContainer {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: ${({ isPortrait }) => (isPortrait ? 0 : 100)}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: ${({ isMuted }) => (isMuted ? 'all' : 'none')};

    /* pointer-events: none; */

    > video {
      width: 100%;
      height: ${({ isPortrait }) => (isPortrait ? 'auto' : '100%')};
      object-fit: ${({ isPortrait }) => (isPortrait ? 'none' : 'contain')};

      track {
        color: red;
      }
    }

    .info {
      position: absolute;
      left: 0;
      bottom: 50px;
      width: 100%;
      text-align: center;
    }
  }

  #touchexp{
    position: absolute;
    left: 10%;
    z-index: 9999;
    pointer-events: "auto";

  }
  #aosexp{
    position: absolute;
    right: 10%;
    z-index: 9999;
    pointer-events: "auto";
  }

  .contentexp{
    box-shadow: 5px 5px  rgb(30, 79, 104), -5px -5px rgb(30, 79, 104);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 300px;
    z-index: 9999;
    pointer-events: auto;
  }

`


export const Heading = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  padding: 24px;
`

export const Bottom = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 80px;
  text-align: center;
`

export const EnterButton = styled.div`
  display: inline-block;
  font-size: 12px;
  padding: 24px 40px;
  border-radius: 27px;
  background-color: ${colors.lightBlue};
  letter-spacing: normal;
  font-weight: normal;
  pointer-events: auto;

  &:hover {
    cursor: pointer;
  }
`
